class IndustryStoriesCarousel extends HTMLElement {
  connectedCallback() {
    this.viewport = this.querySelector(".is-stories__viewport");
    this.track = this.querySelector(".is-stories__track");

    if (!this.viewport || !this.track) return;

    this.speed = 0.6;
    this.position = 0;
    this.trackWidth = 0;
    this.isPaused = false;
    this.isDragging = false;
    this.pointerId = null;
    this.startPointerX = 0;
    this.startPosition = 0;
    this.raf = null;
    this.measure();
    this.bindEvents();
    this.animate = this.animate.bind(this);
    this.raf = requestAnimationFrame(this.animate);
  }
  
  measure() {
    const cards = Array.from(this.track.children);
    
    if (!cards.length) return;
    const originalCount = Math.floor(cards.length / 2);
    
    if (originalCount < 1) return;
    const firstCard = cards[0];
    const lastOriginalCard = cards[originalCount - 1];
    const firstRect = firstCard.getBoundingClientRect();
    const lastRect = lastOriginalCard.getBoundingClientRect();
    
    this.trackWidth = (lastRect.right - firstRect.left) + parseFloat(getComputedStyle(this.track).gap || 0);
  }
  
  bindEvents() {
    this.viewport.addEventListener("mouseenter", () => {this.isPaused = true;});
    this.viewport.addEventListener("mouseleave", () => {if (!this.isDragging) {this.isPaused = false;}});
    this.viewport.addEventListener("pointerdown", this.onPointerDown.bind(this));
    this.viewport.addEventListener("pointermove", this.onPointerMove.bind(this));

    window.addEventListener("pointerup", this.onPointerUp.bind(this));
    window.addEventListener("pointercancel", this.onPointerUp.bind(this));
    window.addEventListener("resize", this.onResize.bind(this));
  }

  onPointerDown(e) {
    this.isDragging = true;
    this.isPaused = true;
    this.pointerId = e.pointerId;
    this.viewport.setPointerCapture(e.pointerId);
    this.viewport.classList.add("is-dragging");
    this.startPointerX = e.clientX;
    this.startPosition = this.position;
  }

  onPointerMove(e) {
    if (!this.isDragging) return;
    const delta = e.clientX - this.startPointerX;

    this.position = this.startPosition + delta;
    this.wrap();
    this.render();
  }

    onPointerUp(e) {
    if (!this.isDragging) return;
    if (this.pointerId !== null && e.pointerId !== this.pointerId) {
      return;
    }

    this.isDragging = false;
    this.pointerId = null;
    this.viewport.classList.remove("is-dragging");

    try {
      this.viewport.releasePointerCapture(e.pointerId);
    } catch (_) {}

    if (!this.viewport.matches(":hover")) {
      this.isPaused = false;
    }
  }

  onResize() {
    requestAnimationFrame(() => {
      this.measure();
      this.wrap();
      this.render();
    });
  }

  animate() {
    if (!this.isPaused && !this.isDragging) {
      this.position -= this.speed;
      this.wrap();
      this.render();
    }
    
    this.raf = requestAnimationFrame(this.animate);
  }

  wrap() {
    if (!this.trackWidth) return;
    
    if (this.position <= -this.trackWidth) {
      this.position += this.trackWidth;
    }
    
    if (this.position >= 0) {
      this.position -= this.trackWidth;
    }
  }

  render() {
    this.track.style.transform = `translate3d(${this.position}px,0,0)`;
  }

  disconnectedCallback() {
    cancelAnimationFrame(this.raf);
  }
}

if (!customElements.get("industry-stories-carousel")) {
  customElements.define("industry-stories-carousel", IndustryStoriesCarousel);
}